export interface RestrictionOptionsObject {
  fileType?: string;
  fileSize?: FileSizeRestriction;
}

export interface FileSizeRestriction {
  sizeNumber: number;
  sizeType: string;
}

export interface FileSizeRestrictions {
  GLOBAL: FileSizeRestriction;
  CARD_PRODUCTION: {
    ARTWORK: FileSizeRestriction;
    ASN: FileSizeRestriction;
    PROOF_OF_PAYMENT: FileSizeRestriction;
    EXTERNAL_PIN: FileSizeRestriction;
    PO_SOW: FileSizeRestriction;
  };
  CARD_DESIGN: {
    ART: FileSizeRestriction;
    ARTWORK: FileSizeRestriction;
  };
  POP_DESIGN: {
    ART: FileSizeRestriction;
    ARTWORK: FileSizeRestriction;
    FS_FILE: FileSizeRestriction;
  };
  POP_PRODUCTION: {
    ARTWORK: FileSizeRestriction;
    ASN: FileSizeRestriction;
    OTHER: FileSizeRestriction;
    PARTNER_ART: FileSizeRestriction;
    PRINTER_PROOF: FileSizeRestriction;
    PRINTER_QUOTE: FileSizeRestriction;
  };
  FINANCIAL_SERVICES: {
    ARTWORK: FileSizeRestriction;
    ASN: FileSizeRestriction;
    FINANCE: FileSizeRestriction;
  };
  BIF_PRODUCTION: {
    ARTWORK: FileSizeRestriction;
    PRINTER_PROOF: FileSizeRestriction;
    ASN: FileSizeRestriction;
    MATRIX: FileSizeRestriction;
  };
  THIRD_PARTY_PRODUCTION: {
    FINANCE: FileSizeRestriction;
    ARTWORK: FileSizeRestriction;
    OPS: FileSizeRestriction;
    ASN: FileSizeRestriction;
    EXTERNAL_PIN: FileSizeRestriction;
  };
  IMAGE: {
    ART_FILE: FileSizeRestriction;
  };
  IH_PRODUCTION: {
    ARTWORK: FileSizeRestriction;
    PRINTER_PROOF: FileSizeRestriction;
    MATRIX: FileSizeRestriction;
  };
}

const DEFAULT_FILE_SIZE_RESTRICTION: FileSizeRestriction = {
  sizeNumber: 50,
  sizeType: 'MB'
};

export const FILE_SIZE_RESTRICTIONS: FileSizeRestrictions = {
  GLOBAL: DEFAULT_FILE_SIZE_RESTRICTION,
  CARD_PRODUCTION: {
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    ASN: DEFAULT_FILE_SIZE_RESTRICTION,
    PROOF_OF_PAYMENT: DEFAULT_FILE_SIZE_RESTRICTION,
    EXTERNAL_PIN: DEFAULT_FILE_SIZE_RESTRICTION,
    PO_SOW: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  CARD_DESIGN: {
    ART: DEFAULT_FILE_SIZE_RESTRICTION,
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  POP_DESIGN: {
    ART: DEFAULT_FILE_SIZE_RESTRICTION,
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    FS_FILE: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  POP_PRODUCTION: {
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    ASN: DEFAULT_FILE_SIZE_RESTRICTION,
    OTHER: DEFAULT_FILE_SIZE_RESTRICTION,
    PARTNER_ART: DEFAULT_FILE_SIZE_RESTRICTION,
    PRINTER_PROOF: DEFAULT_FILE_SIZE_RESTRICTION,
    PRINTER_QUOTE: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  FINANCIAL_SERVICES: {
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    ASN: DEFAULT_FILE_SIZE_RESTRICTION,
    FINANCE: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  BIF_PRODUCTION: {
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    PRINTER_PROOF: DEFAULT_FILE_SIZE_RESTRICTION,
    ASN: DEFAULT_FILE_SIZE_RESTRICTION,
    MATRIX: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  THIRD_PARTY_PRODUCTION: {
    FINANCE: DEFAULT_FILE_SIZE_RESTRICTION,
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    OPS: DEFAULT_FILE_SIZE_RESTRICTION,
    ASN: DEFAULT_FILE_SIZE_RESTRICTION,
    EXTERNAL_PIN: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  IMAGE: {
    ART_FILE: DEFAULT_FILE_SIZE_RESTRICTION,
  },
  IH_PRODUCTION: {
    ARTWORK: DEFAULT_FILE_SIZE_RESTRICTION,
    PRINTER_PROOF: DEFAULT_FILE_SIZE_RESTRICTION,
    MATRIX: DEFAULT_FILE_SIZE_RESTRICTION,
  }
};
